import { combineReducers } from 'redux';
import { routerReducer as routing} from 'react-router-redux';

import lang from './lang';
import inquiryTypes from './inquiryTypes';
import targetSystems from './targetSystems'
import inquiryData from './inquiryReducer';
import locale from './locale';

const rootReducer = combineReducers({
    lang,
    inquiryTypes,
    targetSystems,
    inquiryData,
    locale,
    routing
});

export default rootReducer;